export default __webpack_public_path__ + "static/media/review-1.2a805193.jpg";